import {useCallback} from "react";
import {useAuthStore} from "../store/useAuth.store";

const useRequireAuth = () => {
  const authStatus = useAuthStore(state => state.authStatus);

  const requireAuth = useCallback(
    callback => {
      if (authStatus !== "authenticated") {
        useAuthStore.getState().handleAuthForm("registration");
        useAuthStore.getState().handleShowAuthModal();
        return;
      }
      callback();
    },
    [authStatus]
  );

  return requireAuth;
};

export default useRequireAuth;
